import { LicenseFeature } from '@shared/enums/license-feature.enum';

export type FeatureValue = boolean | any;

export interface FeatureData {
  key: TeamFeature | UserFeature;
  title?: string;
  description?: string;
  value?: FeatureValue;
  licenseFeature?: LicenseFeature;
}

export enum TeamFeature {
  ENABLE_EXPERIMENTAL = 'enable_experimental',
  ALL_FEATURES = 'all_features',
  AI_INTERVIEWER = 'ai_interviewer',
  SURVEY_MAKER_AI = 'survey_maker_ai',
  INTEGRATIONS = 'integrations',
  INSIGHTS = 'insights',
  AI_ANALYSIS = 'ai_analysis',
  SMART_SHARE = 'smart_share',
  SHARED_INSIGHT_CARDS = 'shared_insight_cards',
  BENCHMARK_DATA = 'use_template_answer_comparison',
  BENCHMARK_DATA_FOR_CHILDREN = 'use_template_answer_comparison_for_children',
  AGENTIC_WHYFINDER = 'agentic_whyfinder',
}

export const BetaFeatures: TeamFeature[] = [
  TeamFeature.AI_INTERVIEWER,
  TeamFeature.SURVEY_MAKER_AI,
  TeamFeature.INTEGRATIONS,
  TeamFeature.INSIGHTS,
  TeamFeature.SMART_SHARE,
  // TeamFeature.AI_ANALYSIS,
];

/** Features that child orgs inherit from their parent org when enabled on the parent. */
export const InheritableFeatures: TeamFeature[] = [TeamFeature.AGENTIC_WHYFINDER];

export enum UserFeature {
  AI_ANALYSIS = 'ai_analysis',
}
